import React from 'react';

const ApiImage = ({ src, alt = '', className = '', style = {} }) => {
  if (!src) return null;

  const _src = `${process.env.REACT_APP_API_URL}/api/images?path=${encodeURIComponent(src)}`;

  return (
    <img
      src={_src}
      alt={alt}
      className={className}
      style={style}
    />
  );
};

export default ApiImage;
